export const ADD_TOAST = 'ADD_TOAST';
export const UPDATE_TOAST = 'UPDATE_TOAST';
export const CLEAR_TOAST = 'CLEAR_TOAST';
